export default __webpack_public_path__ + "static/media/IMG_20230606_160930_052.35c0990c.jpg";